export const solutionOptions = [
    {
        id: '1',
        name: '智慧园区',
        // Image: { src: require('@/assets/img/parkSmart.png') },
        Image: { src: require('@/assets/img/smartPark1.png') },
        img: { src: require('@/assets/img/smartPark.jpg') },
        goal: {
            title: '（一）建设目标',
            described: [
                '1、通过智慧园区的建设，帮助园区在信息化方面建立统一的组织管理协调架构、业务管理平台和对内对外服务运营平台。',
                '2、建立统一的工作流程，协同、调度和共享机制，通过云平台的整合，以云平台为枢纽，形成一个紧密联系的整体，获得高效、协同、互动、整体的效益。',
                '3、建立统一的应急管理与日常管理、对内与对外服务这两大服务和两大管理体系。',
                '4、建立统一的应急管理与日常管理、对内与对外服务这两大服务和两大管理体系。'
            ]
        },
        framework: {
            title: '（二）系统架构：智慧园区系统架构如下',
            descri: {
                img: { src: require('@/assets/img/frameWork.png') }
            }
        },
        function: {
            title: '（三）功能模块：系统包含以下功能模块',
            img: { src: require('@/assets/img/funtion.png') },
            described: [
                '园区智慧化应用系统主要体现如下几个方面：',
                '1、园区安全监管方面，主要功能体现：监控监测、预警预报、隐患排查、综合应急联动等方面。',
                '2、园区环保监管方面，如园区有组织、无组织排放监控监测，能源监测、大气污染、水污染监控监测等。',
                '3、园区安防管理方面，如园区封闭式管理、园区内部及周界监控报警管理、园区危化品车辆管理、园区危化品停车场及物流管理等。',
                '4、园区能源管理方面，针对园区企业用能的监控监测，如企业水、电、燃气、蒸汽等数据进行物联网远程采集分析，对园区能源调度及响应政府节能降耗指标起到决策支撑作用。',
                '智慧园区信息服务平台主要包括智能停车、访客登记、感应式门禁通道管理、电梯控制、会议自动签到以及多功能消费管理六个子系统。绿色节能管理系统',
                '调查显示，建筑能耗占国民经济总能耗的1/3，空调和照明则占总耗能的80%以上。如何有效解决能源浪费对于园区耗能管理具有十分重大的意义。智慧园区信息服务平台绿色节能管理系统是针对园区能源管控推出的，通过研究各类园区和企事业单位的能源消耗和节能控制需求，所研发的综合节能管理系统，主要包含智能照明管理、空调节能自控和节水控制等系统。政务办公服务信息平台',
                '政务办公服务信息平台最核心的是拥有安全、高效的云平台数据中心。云平台数据中心实现终端设备的数据汇聚和分析，研究对终端设备的统一调度模型，建立安全的事务管理机制，通过多租户引擎在应用层为用户提供定制化服务。',
                '园区主导的服务体系建设，优化深化服务能力,就需要构建云计算平台，作为基础服务提供商与企业间中央信息处理、存储和计算的中心,集成园区产业链的上下游系统,为企业提供公共服务的园区级的运营服务。通过分析园区服务运营平台的功能和性能需求，以下几个方面显现出了云计算特征:（1）对资源有大规模、超量需求；（2）资源负载变化大；（3）以服务方式提供计算能力。',
                '政务服务云计算平台同时满足政务办公、信息流通和对外展示等需求，并对企业提供包括：（1）业务受理、开通、计费功能；（2）网络节点配置和控制功能；（3）需求信息采集、存储、计算、服务信息展示功能；（4）公共服务平台的应用集成。'
            ],
            content: '智慧园区平台主要包含三类功能模块：智能化应用系统、绿色节能管理和政务办公服务平台。智慧园区信息服务平台面向的对象包括园区管理者、运营商、政府部门、企业和业主。用户的多元化对平台的需求各不相同，因此对不同用户的需求进行分析，研究各类应用的面向对象和领域，通过统一服务管理平台实现应用定制化是最终可以面向各类服务对象的关键。三类功能模块具体设计如下：',
            text: '智能化应用系统',
        },
        platfromDisplay: {
            title: '（四）平台界面示例：',
            img: { src: require('@/assets/img/platfrom.png') },
            described: [
                '智慧园区平台主要包含三类模块：智能化应用系统、绿色节能管理和政务办公服务平台。智慧园区信息服务平台面向的对象包括园区管理者、运营商、政府部门、企业和业主。用户的多元化对平台的需求各不相同，因此对不同用户的需求进行分析，研究各类应用的面向对象和领域，通过统一服务管理平台实现应用定制化是最终可以面向各类服务对象的关键。',
                '系统可根据园区性质、业主的要求、园区的功能定位、智能化基础模块等项具体需求条件，订制功能模块及系统界面。'
            ]
        },
        item: {
            name: '智慧园区',
            item1: ['全景展示', '综合态势', '政务办公', '物业服务', '人员管控', '车辆管理'],
            item2: ['资产管理', '园区安防', '智慧消防', '绿色节能', '环境管理', '系统运维']
        },
        bigData: {
            name: '大数据分析',
            item1: ['综合态势分析', '停车数据分析', '访客数据分析', '安保数据分析'],
            item2: ['设备数据分析', '物业数据分析', '报警数据分析', '能耗数据分析']
        },
        parkImg: [
            require('@/assets/img/smartPark1.png'),
            require('@/assets/img/smartPark2.png'),
            require('@/assets/img/smartPark3.png'),
        ]
    },
    {
        id: '2',
        name: '智慧校园',
        Image: { src: require('@/assets/img/school3.png') },
        img: { src: require('@/assets/img/smarkSchool.jpg') },
        goal: {
            title: '（一）建设目标',
            described: [
                '1、通过智慧校园的建设，帮助学校在信息化方面建立统一的组织管理协调架构、业务管理平台和对内对外服务运营平台。',
                '2、建立统一的工作流程，协同、调度和共享机制，通过云平台的整合，以云平台为枢纽，形成一个紧密联系的整体，获得高效、协同、互动、整体的效益。',
                '3、建立统一的应急管理与日常管理、对内与对外服务这两大服务和两大管理体系。',
                '4、建立统一的综合管理平台，针对校园的安全、环保、应急、能源、教务系统、智慧班牌、宿舍管理、琴房管理、场地管理、校园电视台、IPTV、信息发布、办公等应用需求，建立智慧校园综合管理服务体系。'
            ]
        },
        framework: {
            title: '（二）系统架构',
            descri: {
                img: { src: require('@/assets/img/frameschool.png') },
                text: '智慧校园总体技术架构主要由门户层、应用层、平台层、网络层、感知层（数据采集）等组成。平台层包含业务门户、互联网门户。应用层主要包括面向校园管理类的服务系统、面向教学类的智能应用系统、面向校园生活类的服务系统组成。平台层包括两个主要的平台：以计算服务、存储服务和备份服务为主的基础设施平台；以身份认证、工作流引擎、报表引擎、搜索引擎、数据引擎、资源推送为主的支撑服务平台。 网络层包括互联网、物联网、教育网、校园网，综合网络层又分为网络接入层、网络汇聚层、网络核心层等。感知层主要有视频监控系统的摄像机、楼宇系统前端控制器、资产管理系统RFID、图书RFID、二维码等采集模块组成。'
            }
        },
        function: {
            title: '（三）各子系统及应用场景',

            described: [
                {
                    title: '1、各子系统及应用场景',
                    text: '智慧校园功能模块及对应的应用场景如下图：在学校大门口建设监控系统、一卡通闸机、车辆识别、出入口访客管理等子系统；在教学楼建设电子黑板、电子班牌、监控、广播、录播、智慧教室、节能灯控、实验实训等子系统；在办公楼建设云办公系统、会议系统等子系统；在图书管和报告厅建设图书管管理系统、多功能报告厅系统；在宿舍楼建设出入管理、水电、热水、饮用水、空调管理等子系统；在体育馆建设舞台灯光音响系统；在食堂建设阳光厨房、一卡通消费管理系统等子系统；在运动场及总坪建设监控系统、广播系统、电子围栏系统等子系统；在中心机房建设数据中心、监控系统、智慧校园管理系统等应用软件、平台软件部署。',
                    img: { src: require('@/assets/img/adminSchool1.png') },
                },
                {
                    title: '2、智慧校园综合管理平台',
                    text: '智慧校园综合管理平台是整个校园的信息资源中心和组织管理中心，它的功能主要是对校园各子系统的综合运维管理、统一信息门户、统一身份认证、统一决策管理。',
                    img: { src: require('@/assets/img/adminSchool2.png') },
                    img1: { src: require('@/assets/img/adminSchool21.png') },
                },
                {
                    title: '3、智慧校园业务平台',
                    img: { src: require('@/assets/img/adminSchool3.png') },
                }
            ]
        },
        item: {
            name: '智慧校园',
            item1: ['全景展示', '综合态势', '校园门户', '场地管理', '人员管控', '车辆管理'],
            item2: ['资产管理', '校园安防', '智慧消防', '能耗管理', '环境管理', '系统运维']
        },
        bigData: {
            name: '校园业务系统',
            item1: ['统一身份认证', '教务考勤', '教务考试', '智慧班牌', '智慧食堂', '宿舍管理'],
            itemPic: [
                require('@/assets/zhxy/a1.png'),
                require('@/assets/zhxy/a2.png'),
                require('@/assets/zhxy/a3.png'),
                require('@/assets/zhxy/a4.png'),
                require('@/assets/zhxy/a5.png'),
                require('@/assets/zhxy/a6.png'),
            ],
            bigDataCss: 'bigDataCssImg'
        },
        parkImg: [
            require('@/assets/img/school1.png'),
            require('@/assets/img/school2.png'),
            require('@/assets/img/school3.png'),
        ]
    },
    {
        id: '3',
        name: '智慧医院',
        Image: { src: require('@/assets/zhyy/yy6.png') },
        img: { src: require('@/assets/img/smarkHospital.jpg') },
        goal: {
            title: '（一）建设目标',
            theme: '智慧医院管理系统',
            described: [
                '1、通过智慧医院管理系统的建设，帮助医院在信息化方面建立统一的组织管理协调架构、业务管理平台和对内对外服务运营平台。',
                '2、建立统一的工作流程，协同、调度和共享机制，通过云平台的整合，以云平台为枢纽，形成一个紧密联系的整体，获得高效、协同、互动、整体的效益。',
                '3、建立统一的应急管理与日常管理、对内与对外服务这两大服务和两大管理体系。',
                '4、建立统一的综合管理平台，针对医院的安保服务、应急、能源、设备资产、智慧门诊、护理呼叫、智慧探视、视频示教、信息发布、智慧手术室、人员培训、物业管理、信息发布、办公、运维管理等应用需求，建立智慧医院综合管理服务体系。'
            ]
        },
        framework: {
            title: '（二）系统架构',
            descri: {
                img: { src: require('@/assets/img/hospitalModel.png') },
                text: '智慧医院系统架构主要包含用户层、应用层、平台层、设施层，由于应用层及平台层联系紧密，本架构图将应用层及平台层联合表述。用户层主要包含面向医院管理人员的应用界面及面向医护及患者的应用界面。平台层由智慧医院管理平台及智慧医院业务平台两大平台组成，其中管理平台含安全保障平台及一体化智慧医院、生合、支撑体系，集成了医院安全管理、专业设备管理、建筑设备管理功能；智慧医院业务平台含医闻智能化、临床信息化、医院管理板块。系统集成HIS、LIS、PAS等专业系统，共同构成智慧医院业务平台体系。智慧医院系统集成人工智能技术、大数据分析技术、BIM技术物联网定位技术等先进技术手段，构建两大平台间的中间件数据库，在此基础上实现三维可视化管理、大数据分析、数字孪生交付等新一代智慧医院管理体系。'
            }
        },
        function: {
            title: '（三）各子系统及应用场景',
            described: [
                '1、在医院大门口建设监控系统、人员测温系统、通道闸管理系统。',
                '2、在门诊楼建设智慧门诊系统，含专家排班、信息发布、地图导览、门诊叫号、检查检验叫号等子系统；在门诊楼建设安防系统、公共广播系统、计算机网络系统、综合布线系统、楼宇控制系统等。',
                '3、在医技楼建设医技预约系统、信息发布系统、安防系统、公共广播系统、计算机网络系统、综合布线系统、楼宇控制系统等。',
                '4、在住院楼建设病房呼叫系统、信息发布系统、安防系统、公共广播系统、综合布线系统、计算机网络系统、楼宇控制系统等。',
                '5、在行政楼建设会议系统、手术示教系统、虚拟化桌面系统、公共广播系统、计算机网络系统、综合布线系统、楼宇控制系统等。',
                '6、在中心机房部署各系统应用服务器、UPS系统、机房灭火系统等；部署智慧医院综合管理软件平台；部署HIS、LIS、PAS系统服务器。'

            ],
        },
        platfromDisplay: {
            title: '（四）智慧医院管理平台界面示例',
            img: { src: require('@/assets/img/adminHospital.png') },
        },
        item: {
            name: '智慧医院',
            item1: ['全景展示', '综合态势', '医院门户', '物业服务', '人员管控', '车辆管理'],
            item2: ['楼宇自控', '医院安防', '停车收费', '能耗管理', '智慧消防', '系统运维']
        },
        bigData: {
            name: '医院业务系统',
            item1: ['智慧门诊', '护理呼叫', '智慧探视', '视频示教', '信息发布', '智慧手术室'],
            item2: ['HIS系统', 'LIS系统', 'PAS系统', '办公系统', '资产管理', '医疗物联网']
        },
        parkImgCss: 'imgListA',
        parkImg: [
            require('@/assets/zhyy/yy1.png'),
            require('@/assets/zhyy/yy2.png'),
            require('@/assets/zhyy/yy3.png'),
            require('@/assets/zhyy/yy4.png'),
            require('@/assets/zhyy/yy5.png'),
            require('@/assets/zhyy/yy6.png'),
            require('@/assets/zhyy/yy7.png'),
            require('@/assets/zhyy/yy8.png'),
            require('@/assets/zhyy/yy9.png'),
            require('@/assets/zhyy/yy10.png'),
        ]
    },
    {
        id: '4',
        name: '智慧隧道',
        Image: { src: require('@/assets/img/anlisd.png') },
        img: { src: require('@/assets/img/smarkTunnel.jpg') },
        goal: {
            title: '（一）建设目标',
            described: [
                '1、建设隧道的基础交通诱导系统、环境监测系统、通风控制系统、照明控制系统、水泵控制系统、隧道消防系统、信息发布系统、紧急电话广播系统、视频监控系统。',
                '2、建设隧道的机电系统可视化管理平台，建成全息感知、显示的可视化隧道，并将各独立的隧道管理系统建立集群管理机制，实现集群统一管理，实现隧道管理的信息化、自动化、数字化、集群化。'
            ]
        },
        framework: {
            title: '（二）系统架构',
            descri: {
                img: { src: require('@/assets/img/tunnel1.png') }
            }
        },
        function: {
            title: '（三）系统功能',
            // img: { src: require('@/assets/img/tunnel2.jpg') },
            textInfo: {
                textList: ['交通及诱导控制','交通数据监控','环境数据监测','通风控制','隧道集群联网管控','照明控制模式','信息发布','车行横通道门控制','消防水泵及水位检测','火灾报警监控','紧急电话与有线广播','视频切换显示','隧道实时视频监控','隧道积水超限报警',],
                textCss: 'textCss',
                itemStyle: 'itemStyle'
            },
            described: [
                '通过建设监控中心的隧道可视化集控平台管理软件，可对所辖隧道进行综合监控和管理。它主要实现对隧道内的监控、通风、照明、消防、电力监控等机电设备进行远程综合监控，并可实现各种预案控制和联动控制。并可实现多隧道集中监控，当某个隧道发生报警时，系统能够自动切换到该隧道集控子系统，并现现弹屏预警，可协助管理人员在第一时间调用紧急预案。'
            ],
        },
        platfromDisplay: {
            title: '（四）软件界面',
            img: { src: require('@/assets/img/tunnel3.jpg') },
        },
        item: {
            name: '智慧隧道',
            item1: ['交通诱导', '交通数据', '环境数据', '通风控制', '照明控制', '水泵控制'],
            item2: ['隧道消防', '信息发布', '电话广播', '视频监控', '全息隧道', '集群管理']
        },
        parkImgCss: 'imgListB',
        parkImg: [
            require('@/assets/zhsd/sd0.png'),
            require('@/assets/zhsd/sd1.png'),
            require('@/assets/zhsd/sd2.png'),
            require('@/assets/zhsd/sd3.png'),
            require('@/assets/zhsd/sd4.png'),
            require('@/assets/zhsd/sd5.png'),
        ]
    },
    {
        id: '5',
        name: '智慧工厂',
                Image: { src: require('@/assets/zhgc/gc1.png') },
        img: { src: require('@/assets/img/smarkFactory.jpg') },
        goal: {
            title: '（一）建设目标',
            theme: '智慧工厂管理系统',
            described: [
                '1、通过智慧工厂的建设，帮助工厂在信息化方面建立统一的组织管理协调架构、业务管理平台和对内对外服务运营平台。',
                '2、建立统一的工作流程，协同、调度和共享机制，通过云平台的整合，以云平台为枢纽，形成一个紧密联系的整体，获得高效、协同、互动、整体的效益。',
                '3、建立统一的应急管理与日常管理、对内与对外服务这两大服务和两大管理体系。',
                '4、建立统一的综合管理平台，针对工厂的安保服务、环保、应急、能源、安全生产、设备资产、人员培训、物业管理、信息发布、办公、运维管理等应用需求，建立智慧工厂综合管理服务体系。'
            ]
        },
        framework: {
            title: '（二）系统架构',
            descri: {
                img: { src: require('@/assets/img/factory1.png') },
                text: '随着新一代信息技术发展，制造业的生产管理智能化提升有了技术基础，融合物联网、大数据、云计算、人工智能等技术；打破了传统信息技术为企业服务的能力，企业未来的数字化管理已经不是过去的人、财、物管理，而是实现企业人、设备、物料、产线、订单、产品、供应商、客户、财务等全要素、全流 程、全产业链、全价值链的体系化数字化、智能化管理服务，工业互联网在降本增效、提质降耗、优化资源配置资源配置方面数字化能力更明显，更易实现，因此智慧工厂的智能化管理应运而生，以适应企业在新经济形势下竞争的环境变化。'
            }
        },
        function: {
            title: '（三）系统功能模块',
            img: { src: require('@/assets/img/factory2.png') },
            img3: { src: require('@/assets/img/factory3.jpg') },
            label1: '3.1智慧工厂管理系统',
            text: '智慧工厂管理系统主要包含以下子系统：全景展示、综合态势、物业管理、人员管理、车辆管理、资产管理、园区安防、智慧消防、能耗管理、环境管理、系统运维等子系统。系统具体功能模块可根据工厂性质、业主的要求、工厂的产业情况、智能化基础模块等项具体需求条件，订制功能模块及系统界面。',
            label2: '例：智慧工厂可视化管理系统',
            label3: '3.2 智慧工厂业务系统',
            described: [
                '以《工信部关于开展2018年智能制造试点示范项目推荐的通知》中“流程型智能制造”试点示范项目要素条件为建设目标',
                '1.工厂总体设计、工艺流程及布局均己建立数字化模型，并进行模拟仿真，实现生产流程数据可视化和生产工艺优化。',
                '2.实现对物流、能流、物性、资产的全流程监控，建立数据采集和监控系统，生产工艺数据自动数采率达到90%以上。实现原料、关键工艺和成品检测数据的采集和集成利用，建立实时的质量预警。',
                '3.采用先进控制系统,工厂自控投用率达到90%以上,关键生产环节实现基于模型的先进控制和在线优化。',
                '4.建立生产执行系统(MES),生产计划、调度均建立模型，实现生产模型化分析决策、过程量化管理、成本和质量动态跟踪以及从原材料到产成品的一体化协同优化。建立企业资源计划系统(ERP)，实现企业经营、管理和决策的智能优化。',
                '5.对于存在较高安全与环境风险的项目，实现有毒有害物质排放和危险源的自动检测与监控、安全生产的全方位监控，建立在线应急指挥联动系统。',
                '6.建立工厂通信网络架构，实现工艺、生产、检验、物流等制造过程各环节之间，以及制造过程与数据采集和监控系统、生产执行系统(MES)、 企业资源计划系统(ERP)之间的信息互联互通。',
                '7.建有工业信息安全管理制度和技术防护体系，具备网络防护、应急响应等信息安全保障能力。建有功能安全保护系统，采用全生命周期方法有效避免系统失效。',
                '通过持续改进，实现生产过程动态优化，制造和管理信息的全程可视化，企业在资源配置、工艺优化、过程控制、产业链管理、节能减排及安全生产等方面的智能化水平显著提升。'
            ],
        },
        platfromDisplay: {
            title: '（四）软件界面',
            img: { src: require('@/assets/img/factory4.png') },
            described: [
                '智慧工厂集成管控平台融合物联网、大数据、云计算、人工智能等技术；打破了传统信息技术为企业服务的能力边界，使企业未来的数字化管理已经不是局限于过去的人、财、物管理，而是实现企业人、设备、物料、产线、订单、产品、供应商、客户、财务等全要素、全流程、全产业链、全价值链的体系化数字化、智能化管理服务，智慧工厂管理系统的建立使企业在降本增效、提质降耗、优化资源配置资源配置等方面的能力进一步加强，更有利于企业面向未来的市场竞争。'
            ]
        },
        item: {
            name: '智慧工厂',
            item1: ['全景展示', '综合态势', '企业门户', '物业服务', '人员管控', '车辆管理'],
            item2: ['资产管理', '园区安防', '智慧消防', '能耗管理', '环境管理', '系统运维']
        },
        bigData: {
            name: '工厂业务系统',
            item1: ['生产管理', '设备资产', '办公OA', '生产仿真', '人员培训', '应急指挥'],
            item2: ['物料管理', '成品管理', '供应链', '营销管理', '安全生产', '研发管理']
        },
        parkImgCss: 'imgListA',
        parkImg: [
            require('@/assets/zhgc/gc1.png'),
            require('@/assets/zhgc/gc2.png'),
            require('@/assets/zhgc/gc3.png'),
            require('@/assets/zhgc/gc4.png'),
            require('@/assets/zhgc/gc5.png'),
        ]
    },
    {
        id: '6',
        name: '智慧景区/公园',
        Image: { src: require('@/assets/zhyq/yq4.png') },
        img: { src: require('@/assets/img/smarkScenic.jpg') },
        goal: {
            title: '（一）建设目标',
            theme: '智慧工厂管理系统',
            described: [
                '1、通过智慧景区的建设，帮助景区在信息化方面建立统一的组织管理协调架构、业务管理平台和对内对外服务运营平台。',
                '2、建立统一的工作流程，协同、调度和共享机制，通过云平台的整合，以云平台为枢纽，形成一个紧密联系的整体，获得高效、协同、互动、整体的效益。',
                '3、建立统一的应急管理与日常管理、对内与对外服务这两大服务和两大管理体系。',
                '4、建立统一的综合管理平台，针对景区的安保服务、环保、应急、能源、设备资产、人员培训、物业管理、信息发布、办公、运维管理等应用需求，建立智慧景区综合管理服务体系。'
            ]
        },
        framework: {
            title: '（二）系统架构',
            descri: {
                img: { src: require('@/assets/img/scenic1.png') },
            }
        },
        function: {
            title: '（三）功能模块',
            img: { src: require('@/assets/img/scenic2.png') },
            img3: { src: require('@/assets/img/scenic3.png') },
            label1: '3.1景区管理系统',
            text: '景区管理系统是应用现代计算机技术、网络技术和通讯技术，构建景区日常管理体系。通过平台的建立，及时、有效地整合旅游信息，为日常管理、辅助决策提供服务，促进景区的管理更加规范化、科学化、智能化；强化行业监管，为景区服务质量的提升打下坚实基础,提高各类旅游突发事件应急处置能力，保障游客的生命财产安全；系统独立，融合性、扩展性强，不易形成信息孤岛，使得系统可以共享互联，做到统一管理、统一登录、数据互联互动，使得各个子系统能够集成到一个平台上面，方便用户集中管理，实现监测、预警、应急信息发布等全环节监测。',
            label4: '例：移动端APP功能说明',
            label3: '3.2景区业务系统',
            described: [
                ' 智慧景区业务系统包括：智慧服务体系、智慧营销体系、智慧体验体系。其中，智慧服务体系子项目包含景区APP、智慧票务、智慧导览、智慧路灯、智慧厕所等项；智慧营销体系子项目包含线上营销（电子商务、旅游产品分销系统、IPTV等）、手中营销（微信、微博、微官网、手机分销系统、微营销）、线下营销（旅行社、酒店、农家乐、门店、传统渠道等）；智慧体验体系包含：游客体验中心、智慧展示（大屏显示+电子沙盘+GIS+触摸屏）、720度全景互动、AR增强现实（实景互动、智能导游图、多维导览）、VR游览、智能步道、AI互动等。'
            ],
        },
        item: {
            name: '智慧景区',
            item1: ['全景展示', '综合态势', '园区门户', '物业服务', '人员管控', '车辆管理'],
            item2: ['资产管理', '园区安防', '智慧消防', '能耗管理', '环境管理', '系统运维']
        },
        bigData: {
            name: '业务系统',
            item1: ['智慧票务', '智慧导览', '移动终端', '智慧展示', '智慧健身', '无人售货'],
            item2: ['AI互动', '智慧路灯', '智能步道', 'VR游览', '智慧厕所', '客流分析']
        },
        parkImgCss: 'imgListA',
        parkImg: [
            require('@/assets/zhyq/yq1.png'),
            require('@/assets/zhyq/yq2.png'),
            require('@/assets/zhyq/yq3.png'),
            require('@/assets/zhyq/yq4.png'),
            require('@/assets/zhyq/yq5.png'),
        ]
    },
    {
        id: '7',
        name: '智能化系统集成',
        Image: { src: require('@/assets/img/systenSmart.png') },
        img: { src: require('@/assets/img/systemIntegration.png') },
        text1: '我公司自2006年成立以来，一直在智能化系统领域精耕细作，公司核心团队成员具有近20年的行业建设经验，能独立承建政府大楼、学校、医院、写字楼、工业厂房、部队军营、住宅小区等各类建筑的建筑智能化系统。系统主要包括网络视频监控系统、楼宇对讲系统、周界防范报警系统、综合布线系统、电子巡更系统、有线电视系统、出入口管理系统、机房工程、停车场管理系统等十几个子系统。',
        img1: { src: require('@/assets/img/integration1.png') },
        integration1Item: [
            {
                title: '楼宇自控解决方案',
                text: '楼宇自控系统主要包括中央空调系统的监控管理、给排水系统的监控管理、供配电监控管理、能源管理、照明系统的控制管理等，涉及的管理监测设备有BA系统服务器、BA工作站、网络控制器、DDC控制器等；被管理监测设备含冷水机组、冷却塔、送排风机、公共照明、暖通空调、送排风、水泵、锅炉、电梯等设备。楼宇控制系统的建设对于现代建筑意义重大，系统具有方便设备管理、提升建筑节能效益、延长机电设备的使用寿命等实际意义，我公司工程合作的楼宇智控产品有霍尼维尔、江森、西门子、百斯顿等国内外一线品牌。',
                img: { src: require('@/assets/img/integration2.png') }
            },
            {
                title: '安全防范系统解决方案',
                text: '安全防范系统简称安防系统，主要包括视频通道系统、人员通道管理系统、停车管理系统、报警系统、巡更系统等。我公司主要与海康威视、大华等国内安防龙头企业合作，为客户建设安全防范系统。',
                img: { src: require('@/assets/img/integration3.png') }
            },
            {
                title: '信息通信系统解决方案',
                text: '信息通信系统建设，主要包括综合布线、程控电话、网络系统、信息发布、中心机房系统建设等。我公司主要与TCL罗格朗、普天天纪、大唐电信、FGT等企业产品合作建设综合布线系统；与申鸥、AVAYA、华为等公司产品合作为客户建设程控电话系统；与华为、华三、锐捷公司产品合作建设计算机网络系统；与海康威视、京东方等企业产品合作建设信息发布系统；与华为、伊顿、山特等公司产品合作建设中心机房数据中心项目。',
                img: { src: require('@/assets/img/integration4.png') }
            }
        ],
        item: {
            name: '智能化系统',
            item1: ['综合布线', '视频监控', '停车管理', '公共广播', '报警系统'],
            item2: ['楼宇对讲', '楼宇自控', '信息发布', '通道管理', '机房工程']
        },
        parkImgCss: 'imgListC',
        parkImg: [
            require('@/assets/xt/xt1.png'),
            require('@/assets/xt/xt2.png'),
        ]
    },
]